import store from '@/store';
import { isPr53Env } from '@/utils';

/**
 * Returns true when the CL (Content Lab) experience should be enabled.
 * Outside PR53 this always returns true (no-op) so US prod and EU prod
 * behaviour is completely unchanged. For PR53 the Use_CL_EU_Processing
 * feature flag controls the gate.
 */
export function isCLEUProcessingEnabled(): boolean {
  if (!isPr53Env()) {
    return true;
  }
  return store?.getters['org/getCurrentOrg']?.Use_CL_EU_Processing ?? false;
}
